import { useTranslation } from "react-i18next";

import {
  LEADERBOARD_GRID_COMPACT,
  LeaderboardPrizeRow,
} from "./tournament-leaderboard-table";
import type { PrizeSchema } from "@/types";
import { cn } from "@/lib/utils";
import { formatPrizeTitle } from "@/utils/helpers";

/**
 * The tournament's prize table as a board: the same grid, row surfaces and podium treatment as
 * the leaderboard, so "what you can win" and "where you stand" are visibly the same table.
 * Replaces the earlier expandable prize list.
 */
export const TournamentPrizeBoard = ({
  prizes,
  className,
}: {
  prizes: PrizeSchema[];
  className?: string;
}) => {
  const { t } = useTranslation();
  if (!prizes?.length) return null;
  return (
    <div
      className={cn(
        "prize-board w-full gap-y-0.5 overflow-hidden rounded-(--border-radius-inner)",
        LEADERBOARD_GRID_COMPACT,
        className
      )}
    >
      {prizes.map((prize, i) => (
        <LeaderboardPrizeRow
          key={`${prize.place_from ?? "x"}-${prize.place_to ?? "x"}-${i}`}
          from={prize.place_from}
          to={prize.place_to}
          prize={formatPrizeTitle(prize.title, t)}
          games={prize.games ?? []}
        />
      ))}
    </div>
  );
};
